module.exports = __webpack_public_path__ + "img/photo.2b8257e4.png";